<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Coupon</h3>
        </v-flex>
        <v-flex xs12 md4 sm5 class="pa-1">
          <v-card>
            <v-card-title class="pt-0">
              {{ coupon.code }}
              <v-spacer></v-spacer>
              Used: {{ coupon.used }} times
            </v-card-title>
            <v-card-text>
              <my-details header="Created">
                {{ coupon.created_at }}, {{ moment(coupon.created_at).fromNow() }}
              </my-details>
              <my-details header="Discount Awarded">
                {{ coupon.discount }}%
              </my-details>
              <my-details header="Expiry">
                {{ coupon.expiry }}, {{ moment(coupon.expiry).fromNow() }}
              </my-details>
              <my-details header="Limit">
                {{ coupon.limit }}
              </my-details>
              <my-details header="Used">
                {{ coupon.used }}
              </my-details>
              <my-details header="Created By">
                {{ coupon.user.name }}
              </my-details>
            </v-card-text>
            <v-card-actions class="pb-0">
              <v-spacer></v-spacer>
              <v-btn small @click="goTo('/coupons/' + coupon.id + '/edit')" title="Edit Coupon" color="warning" icon>
                <v-icon>{{ icons.edit }}</v-icon>
              </v-btn>
              <v-btn small @click="deleteCoupon(coupon)" color="error" icon title="Delete Coupon">
                <v-icon>{{ icons.delete }}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md8 sm7 class="pa-1">
          <v-card>
            <v-card-title class="">
              <v-spacer></v-spacer>
              <v-badge :content="invoices.length" :value="invoices.length" color="green" overlap>
                Invoices
              </v-badge>
            </v-card-title>
            <v-card-text>
              <invoices-table :invoices="invoices"></invoices-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const InvoicesTable =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "invoices" */ '@/Components/Invoices/invoices')
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')

  export default {
    name: 'ViewCoupon',
    layout,
    props: [
      'coupon',
      'canEdit',
      'canDelete',
    ],
    components: {
      InvoicesTable,
      MyDetails,
    },
    metaInfo () {
      return {
        title: 'Coupon',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      deleteCoupon (coupon) {
        swal({
          title: coupon.code,
          text: 'Delete this coupon?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.delete('/coupons/' + coupon.id, {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
    },
    computed: {
      invoices () {
        return this.coupon.invoices
      },
    },
  }
</script>
